<script setup>
import { ref, onBeforeUnmount, onMounted } from 'vue'
import eventBus from '@core/utils/eventBus'
import { setDomFontSize } from '@core/utils/index.js'
import { initUserStore, useUserStore, bootstrapNewPlayerSession } from '@core/store/user.js'
import PayView from '@components/iframeView/pay.vue'
import { initGameStore } from '@core/store/game.js'
import { initVipStore } from '@core/store/vip.js'
import { initConfigStore, useConfigStore } from '@core/store/config.js'
import { useSocket } from '@core/socket/core.js'
import { traceEvent } from '@core/utils/fbq.js'
import router from '@core/router/index.js'
import { showWelcome } from '@components/popup/welcome/index.js'
import { vantThemeVars } from '@core/config/theme-vars.js'

initConfigStore()
initUserStore()
initVipStore()
initGameStore()

const iframeMessage = event => {
  eventBus.emit('iframeMessage', event)
}

const socket = ref(null)

const userStore = useUserStore()
const configStore = useConfigStore()

const loginSuccess = () => {
  if (!socket.value?.isOpen || !userStore.isLogin) return
  socket.value.sendMessage(
    JSON.stringify({
      cmd: 'login',
      data: userStore.user.token,
    }),
  )
}

const initWebSocket = () => {
  socket.value = useSocket()
  socket.value.subscribe('open', () => {
    console.info('WebSocket连接成功!')
    loginSuccess()
  })

  socket.value.subscribe('message', (result) => {
    try {
      const data = JSON.parse(result)
      const cmd = data.cmd

      console.log('cmd:', cmd, 'data:', data.data)

      if (cmd === 'roundid') {
        const result = JSON.parse(data.data)
        eventBus.emit('roundid', result.roundid)
      }

      if (cmd === 'beginer_limit') {
        eventBus.emit('beginer_limit')
      }

      // 充值完成
      if (cmd === 'charge_success') {
        userStore.freshBalance()
        // result = { pay: Number, firstpay: Boolean, orderId: String }
        const result = JSON.parse(data.data)
        const event = result.firstpay ? 'first_pay_event' : 'routine_pay_event'
        const traceParams = {}
        if (result.pay >= 0.001) {
          traceParams.revenue = result.pay
          traceParams.currency = configStore.currency
        }
        if (result.orderId) {
          traceParams.orderId = result.orderId
        }
        traceEvent(event, traceParams)

        if (result.firstpay && router.currentRoute.value.path !== '/game') {
          router.push('/')
        }
      }

      if (cmd === 'otherlogin') {
        userStore.logout()
      }

    } catch (e) {}
  })

  socket.value.subscribe('reconnect', (_socket) => {
    console.info('WebSocket断开重连:', _socket)
    socket.value = _socket
  })
}

onMounted(async () => {
  initWebSocket()
  window.addEventListener('resize', setDomFontSize)
  window.addEventListener('message', iframeMessage)
  eventBus.on('loginSuccess', loginSuccess)

  await bootstrapNewPlayerSession(userStore)
  if (!userStore.isLogin) {
    showWelcome()
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setDomFontSize)
  window.removeEventListener('message', iframeMessage)
  eventBus.off('loginSuccess', loginSuccess)
})
</script>

<template>
  <van-config-provider :theme-vars="vantThemeVars" class="app-root">
    <div class="router-view relative">
      <router-view v-slot="{ Component }">
        <KeepAlive>
          <component :is="Component"/>
        </KeepAlive>
      </router-view>
    </div>

    <pay-view/>
  </van-config-provider>
</template>

<style lang="scss">
.app-root {
  height: 100%;
}

.router-view {
  height: 100%;
  overflow-x: hidden;
}
</style>
